module.exports = __webpack_public_path__ + "img/008-penguin.2003ffbd.svg";